const ARRAY_SUFFIX = '[]';

export const serializeFormData = (formData: FormData) => {
  const data: Record<string, unknown> = {};
  formData.forEach((value, key) => {
    if (key.endsWith(ARRAY_SUFFIX)) {
      const newKey = key.slice(0, -ARRAY_SUFFIX.length);
      data[newKey] = formData.getAll(key);
    } else {
      data[key] = value;
    }
  });
  return data;
};

export const serializeFormDataFromForm = (form: HTMLFormElement) => {
  const formData = new FormData(form);
  return serializeFormData(formData);
};
